import {Pattern, match} from 'ts-pattern';

import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

type FormatDateTime = (format: 'timeShort' | 'dateTimeShort', date: Date) => string;

export function getUserAbsenceReturnText(
  returnsAt: string | null,
  formatDateTime: FormatDateTime,
  now: Date = new Date()
): string {
  const returnsAtDate = returnsAt ? parseDate(returnsAt) : null;

  return match(returnsAtDate)
    .with(Pattern.nullish, () => i18n.t('entity.userAbsence.tooltip.awayOpenEnded'))
    .when(
      (date) => date.toDateString() === now.toDateString(),
      (date) =>
        i18n.t('entity.userAbsence.tooltip.awayReturnsSameDay', {
          time: formatDateTime('timeShort', date),
        })
    )
    .otherwise((date) =>
      i18n.t('entity.userAbsence.tooltip.awayReturns', {
        date: formatDateTime('dateTimeShort', date),
      })
    );
}
